module.exports = __webpack_public_path__ + "media/application/images/svgs/search-grey-98a7a88203d196f88acf40792379c08c.svg";